import { render, staticRenderFns } from "./CardFaqs.vue?vue&type=template&id=82446ce4&scoped=true"
import script from "./CardFaqs.vue?vue&type=script&lang=js"
export * from "./CardFaqs.vue?vue&type=script&lang=js"
import style0 from "./CardFaqs.vue?vue&type=style&index=0&id=82446ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82446ce4",
  null
  
)

export default component.exports